import styled from 'styled-components'

const HeadListWrapper = styled.div`
    display: flex;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    
    .titulo {
        font-size: 17px;
        font-weight: 700;
        padding-left: 10px;
    }
    .tributos{
        flex: 1 32%;
        justify-content: center;
        display: flex;
    }
    .dataVencimento{
        flex: 1 9%;
    }
    .cota{
        flex: 1 9%;
    }
    .inscrição{
        flex: 1 9%;
    }
    .endereço{
        flex: 1 25%;
    }
    .valor{
        flex: 1 21%;
        justify-content: center;
        display: flex;
    }
`;

export default HeadListWrapper